export const base = '/advanced-report';
export const dashboard = `${base}`;
export const templates = `${base}/templates`;
export const templates__section = `${base}/templates/:section`;
export const templates__section__template = `${base}/templates/:section/:template`;
export const builder = `${base}/builder`;
export const builder__section = `${base}/builder/:section`;
export const builder__section__delete = `${base}/builder/:section/delete`;

export const cartograms = `${base}/cartograms`;
export const cartograms__section = `${cartograms}/:section`;
export const cartograms__section__map = `${cartograms}/:section/:map`;
